import { render } from "./eventItem.vue?vue&type=template&id=73673a86&scoped=true"
import script from "./eventItem.vue?vue&type=script&lang=js"
export * from "./eventItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "../style.less?vue&type=style&index=0&module=true&lang=css&external"
cssModules["$style"] = style0
import "./eventItem.vue?vue&type=style&index=1&id=73673a86&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-73673a86"]])

export default __exports__